import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { NotificationService } from 'src/app/services/notification.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppFilesService } from 'src/app/services/app-files.service';
import { DocumenteCetateanService } from '../../documente-cetatean/documente-cetatean.service';
import Swal from 'sweetalert2';
import { BorderouService } from '../borderou.service';

@Component({
    selector: 'app-add-borderou',
    templateUrl: './add-borderou.component.html',
    styleUrls: ['./add-borderou.component.scss']
})
export class AddBorderouComponent implements AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    helper = helper;
    isLoading = false;
    searchPressed = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    selectedRowIds: number[] = [];
    rowCount = 0;
    checkboxSelections = false;

    dtLink = environment.interop.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.searchDocuments;

    form: FormGroup = new FormGroup({
        date_start: new FormControl('', [Validators.required]),
        date_end: new FormControl('', [Validators.required]),
    })

    constructor(
        private http: HttpClient,
        private dialogRef: MatDialogRef<AddBorderouComponent>,
        private borderouService: BorderouService,
        private appFilesService: AppFilesService,
        private documenteCetateanService: DocumenteCetateanService
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit(): void {
        this.renderDT();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 100,
            order: [[1, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.number_of_days = this.getNumberOfDays();

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            lengthMenu: [100],
            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'id_document',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id_document}" />`
                    }
                },
                {
                    title: 'ID Document',
                    data: 'id_document',
                },
                {
                    title: 'ID Cetățean',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        let cnp_cif;

                        if (row.f_nume === '') {
                            cnp_cif = 'CNP';
                        } else {
                            cnp_cif = 'CIF';
                        }

                        return `
                            <div class="d-flex flex-column">
                                ` + (row.f_nume !== '' ? `<span class="d-flex align-items-center gap-1"><img src="/assets/icons/companii.svg" alt="Image" style="width: 20px; height: 20px;">${row.f_nume}</span>` : '') + `
                                <span class="d-flex align-items-center gap-1"><img src="/assets/icons/icon-user.svg" alt="Image" style="width: 20px; height: 20px;">${row.citizen_name}</span>
                                <span>${cnp_cif}: ${row.cnp_cif}</span>
                                ` + (row.notificare_sms_allow == true ? `<span class="d-flex align-items-center gap-1"><i class="fa-solid fa-phone"></i> ${row.notificare_sms_number}</span>` : '') + `
                                ` + (row.notificare_email_allow == true ? `<span class="d-flex align-items-center gap-1"><i class="fa-regular fa-envelope"></i> ${row.notificare_email_address}</span>` : '') + `
                            </div>
                        `;
                    }
                },
                {
                    title: 'Tip Document',
                    data: 'document_type_name',
                    orderable: false,
                },
                {
                    title: 'Data încărcării',
                    data: 'uploaded_date',
                    render: (data: any) => {
                        return this.formatRomanianDate(data);
                    }
                },
                {
                    title: 'Fișiere listate',
                    data: 'files',
                    orderable: false,
                    className: 'all',
                    render: (row: any) => {
                        const icon = '<img src="assets/icons/icon-download.svg" alt="Icon download" />';
                        return row.map((file: any) => `<span style="cursor: pointer;" class="d-flex gap-2 align-items-center file-link" data-id-fisier="${file.id_fisier}">${icon} <span style="color: #0044CC99;">${file.orig_name}</span></span></span>`).join('<br>');
                    }
                },
                {
                    title: 'Data arhivării',
                    data: null,
                    render: (row: any) => {
                        if (row.archive_date !== null) {
                            return `<span>${this.formatRomanianDate(row.archive_date)}</span>`;
                        } else {
                            return `<span>N/A</span>`;
                        }
                    }
                },
                {
                    title: 'Data actualizării',
                    data: 'updated_at',
                    render: (data: any) => {
                        return this.formatRomanianDate(data);
                    }
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');
                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idDocument = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idDocument);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idDocument
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                const fileLinks = (row as HTMLElement).querySelectorAll('.file-link');
                fileLinks.forEach(fileLink => {
                    fileLink.addEventListener('click', () => {
                        const { id_document } = data;
                        const id_fisier = parseInt(fileLink.getAttribute('data-id-fisier') || '0', 10);
                        this.downloadDocument(id_document, id_fisier);
                    });
                });

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: any) => {
                            self.selectedRowIds.push(item.id_document);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        }
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }

    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }

    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    formatRomanianDate(dateTimeString: string): string {
        const [datePart, timePart] = dateTimeString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}.${month}.${year} ${timePart}`;
    }

    downloadDocument(idDocument: number, idFisier: number) {
        let fullPath = this.documenteCetateanService.fileDownloadUrl + idDocument + '/' + idFisier;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    customRound(days: number): number {
        const fraction = days % 1;
        if (fraction.toString().startsWith('0.999')) {
            return Math.ceil(days);
        } else {
            return Math.floor(days);
        }
    }

    getNumberOfDays() {
        if (this.form.get('date_start')?.value === '' && this.form.get('date_end')?.value === '') {
            return 0;
        }

        if ((this.form.get('date_start')?.value === '' && this.form.get('date_end')?.value !== '') || (this.form.get('date_start')?.value !== '' && this.form.get('date_end')?.value === '')) {
            this.searchPressed = false;
            return 0
        }

        if (new Date(this.form.get('date_start')?.value).getTime() > new Date(this.form.get('date_end')?.value).getTime()) {
            this.searchPressed = false;
            return 0
        }

        return this.customRound((new Date(this.form.get('date_end')?.value).getTime() - new Date(this.form.get('date_start')?.value).getTime()) / (1000 * 60 * 60 * 24));
    }

    searchDocuments(paginate = false): void {
        this.isLoading = true;
        this.searchPressed = true;

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.clear().destroy();
            this.dtTrigger.next('');
        });
    }

    submitForm() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Doriți ca documentele selectate să nu mai fie afișate cetățeanului?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'select',
            inputOptions: {
                '-1': '-- Alegeți --',
                true: 'Da',
                false: 'Nu'
            },
            inputValidator: (value: any) => {
                if (value === '-1') {
                    return 'Este necesară alegerea unei opțiuni!';
                }
                return null;
            },
            preConfirm: (inputValue) => {
                if (inputValue === '-1') {
                    Swal.showValidationMessage('Este necesară alegerea unei opțiuni!');
                    return false;
                }

                return this.borderouService
                    .generateBorderou(this.getNumberOfDays(), this.selectedRowIds, inputValue === 'true')
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.showValidationMessage(`${error.error.errors.message[0]}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Borderou generat cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.dialogRef.close({ success: true });
                });
            }
        });
    }
}
